import React from 'react'
import Header from './include/Header'
import Footer from './include/Footer'
function Services() {
    return (
        <>
            <Header />
            <div className="our-services-projects">
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">
                            <div className="section-title section-title-center">
                                <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                    Our <span>Services & Products</span>
                                </h2>
                            </div>
                        </div>
                    </div>
                    {/* Services Section */}
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp">
                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="https://ik.imagekit.io/i3giodzh1/images/ai_solution.jpg" alt="AI Business Solution" />
                                    </figure>
                                    {/*  <div className="post-readmore-btn">
                            <a href="#"><img src="/assets/images/arrow-white.svg" alt="" /></a>
                        </div> */}
                                </div>
                                <div className="post-item-body">
                                    <div className="post-meta">
                                        <ul>
                                            <li><span>Service</span></li>
                                        </ul>
                                    </div>
                                    <div className="post-item-content">
                                        <h2>AI Business Solution</h2>
                                        <p>Intelligent automation, predictive analytics, and custom AI models to transform your business.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="https://ik.imagekit.io/i3giodzh1/images/web_application.jpg" alt="Web App Development" />
                                    </figure>
                                    {/*   <div className="post-readmore-btn">
                            <a href="#"><img src="/assets/images/arrow-white.svg" alt="" /></a>
                        </div> */}
                                </div>
                                <div className="post-item-body">
                                    <div className="post-meta">
                                        <ul>
                                            <li><span>Service</span></li>
                                        </ul>
                                    </div>
                                    <div className="post-item-content">
                                        <h2>Web App Development</h2>
                                        <p>Modern, scalable, and high-performance web applications tailored to your business needs.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" data-wow-delay="0.4s">
                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="https://ik.imagekit.io/i3giodzh1/images/android_apps.jpg" alt="Mobile App Development" />
                                    </figure>
                                    {/* <div className="post-readmore-btn">
                            <a href="#"><img src="/assets/images/arrow-white.svg" alt="" /></a>
                        </div> */}
                                </div>
                                <div className="post-item-body">
                                    <div className="post-meta">
                                        <ul>
                                            <li><span>Service</span></li>
                                        </ul>
                                    </div>
                                    <div className="post-item-content">
                                        <h2>Android & iOS App Development</h2>
                                        <p>Native and cross-platform mobile applications with exceptional user experience.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Products Section */}
                    <div className="row mt-5">
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp">
                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="https://ik.imagekit.io/i3giodzh1/images/dharmiq_app.png" alt="Dharmiq App" />
                                    </figure>
                                    {/* <div className="post-readmore-btn">
                            <a href="#"><img src="/assets/images/arrow-white.svg" alt="" /></a>
                        </div> */}
                                </div>
                                <div className="post-item-body">
                                    <div className="post-meta">
                                        <ul>
                                            <li><span>Product</span></li>
                                        </ul>
                                    </div>
                                    <div className="post-item-content">
                                        <h2>Dharmiq App</h2>
                                        <p>Your daily spiritual companion with bhajans, mantras, and divine content.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="https://ik.imagekit.io/i3giodzh1/images/web_application.jpg" alt="Audiofy" />
                                    </figure>
                                    {/* <div className="post-readmore-btn">
                            <a href="#"><img src="/assets/images/arrow-white.svg" alt="" /></a>
                        </div> */}
                                </div>
                                <div className="post-item-body">
                                    <div className="post-meta">
                                        <ul>
                                            <li><span>Product</span></li>
                                        </ul>
                                    </div>
                                    <div className="post-item-content">
                                        <h2>Audiofy</h2>
                                        <p>Premium audio experience platform for music, podcasts, and audiobooks.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" data-wow-delay="0.4s">
                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="https://ik.imagekit.io/i3giodzh1/images/web_application.jpg" alt="OCR Document Scanner" />
                                    </figure>
                                    {/* <div className="post-readmore-btn">
                            <a href="#"><img src="/assets/images/arrow-white.svg" alt="" /></a>
                        </div> */}
                                </div>
                                <div className="post-item-body">
                                    <div className="post-meta">
                                        <ul>
                                            <li><span>Product</span></li>
                                        </ul>
                                    </div>
                                    <div className="post-item-content">
                                        <h2>OCR Document Scanner</h2>
                                        <p>Advanced AI-powered document scanning and text extraction tool.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" data-wow-delay="0.4s">
                                <div className="post-featured-image">
                                    <figure className="image-anime">
                                        <img src="https://ik.imagekit.io/i3giodzh1/images/web_application.jpg" alt="OCR Document Scanner" />
                                    </figure>
                                    {/* <div className="post-readmore-btn">
                            <a href="#"><img src="/assets/images/arrow-white.svg" alt="" /></a>
                        </div> */}
                                </div>
                                <div className="post-item-body">
                                    <div className="post-meta">
                                        <ul>
                                            <li><span>Product</span></li>
                                        </ul>
                                    </div>
                                    <div className="post-item-content">
                                        <h2>Face Scanner</h2>
                                        <p>Advanced AI-powered face recognition and scanning tool.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Services
